import _ from 'lodash';
import { getRandomInt } from '~/shared';
import mapImage1 from '../../assets/images/connection_map_1.jpg';
import mapImage2 from '../../assets/images/connection_map_2.jpg';
import mapImage3 from '../../assets/images/connection_map_3.jpg';

const MAP_COUNT = 3;

export const mapImages = [mapImage1, mapImage2, mapImage3];

export const indicatorColors = {
	default: ['#ff0000', '#00ff00'],
	pairs: ['#FF3CA7', '#FF832B', '#015AFF', '#FFCC00'],
};

export const mapSwitches = [
	[
		{
			id: 1,
			x: 130,
			y: 324,
			isVertical: false,
		},
		{
			id: 2,
			x: 249,
			y: 479,
			isVertical: true,
		},
		{
			id: 3,
			x: 409,
			y: 411,
			isVertical: true,
		},
		{
			id: 4,
			x: 500,
			y: 224,
			isVertical: false,
		},
		{
			id: 5,
			x: 599,
			y: 409,
			isVertical: true,
		},
		{
			id: 6,
			x: 790,
			y: 194,
			isVertical: true,
		},
		{
			id: 7,
			x: 810,
			y: 460,
			isVertical: false,
		},
		{
			id: 8,
			x: 920,
			y: 350,
			isVertical: false,
		},
	],
	[
		{
			id: 1,
			x: 150,
			y: 223,
			isVertical: false,
		},
		{
			id: 2,
			x: 209,
			y: 429,
			isVertical: true,
		},
		{
			id: 3,
			x: 300,
			y: 460,
			isVertical: false,
		},
		{
			id: 4,
			x: 411,
			y: 409,
			isVertical: true,
		},
		{
			id: 5,
			x: 599,
			y: 409,
			isVertical: true,
		},
		{
			id: 6,
			x: 700,
			y: 460,
			isVertical: false,
		},
		{
			id: 7,
			x: 801,
			y: 429,
			isVertical: true,
		},
		{
			id: 8,
			x: 850,
			y: 223,
			isVertical: false,
		},
	],
	[
		{
			id: 1,
			x: 150,
			y: 223,
			isVertical: false,
		},
		{
			id: 2,
			x: 249,
			y: 479,
			isVertical: true,
		},
		{
			id: 3,
			x: 325,
			y: 316,
			isVertical: false,
		},
		{
			id: 4,
			x: 411,
			y: 330,
			isVertical: true,
		},
		{
			id: 5,
			x: 599,
			y: 330,
			isVertical: true,
		},
		{
			id: 6,
			x: 675,
			y: 316,
			isVertical: false,
		},
		{
			id: 7,
			x: 761,
			y: 484,
			isVertical: true,
		},
		{
			id: 8,
			x: 850,
			y: 223,
			isVertical: false,
		},
	],
];

export const generateGameField = () => {
	const randomMapNumber = getRandomInt(1, MAP_COUNT);
	const level = getRandomInt(1, 3);
	const bg = mapImages[randomMapNumber - 1];
	const allSwitches = mapSwitches[randomMapNumber - 1];

	let switchesCount;
	let colors: string[];
	if (level === 1) {
		switchesCount = getRandomInt(2, allSwitches.length);
		colors = indicatorColors.default;
	} else {
		const maxPairs = Math.floor(allSwitches.length / 2);
		const minPairs = 2;
		const pairsCount = getRandomInt(minPairs, maxPairs);
		switchesCount = pairsCount * 2;
		colors = _.shuffle(indicatorColors.pairs).slice(0, pairsCount);
	}

	const switches = _.sampleSize(allSwitches, switchesCount);

	const switchesWithState = switches.map((switch_, index) => {
		const baseSwitch = { ...switch_, isActive: false };

		if (level === 1) {
			return {
				...baseSwitch,
				color: indicatorColors.default[0],
			};
		} else {
			const pairIndex = Math.floor(index / 2);
			return {
				...baseSwitch,
				color: colors[pairIndex],
				pairId: pairIndex,
			};
		}
	});

	return {
		bg,
		switches: switchesWithState,
		level,
		colors,
		mapNumber: randomMapNumber,
	};
};
